import React, { Component } from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { FaAngleLeft } from "react-icons/fa"
import { FaAngleRight } from "react-icons/fa"
import "./SimpleSlider.css"

function RightNavButton(props) {
  const { style, onClick } = props
  return (
    <FaAngleRight
      className="slick-arrow"
      style={{ ...style }}
      onClick={onClick}
      size="40px"
    ></FaAngleRight>
  )
}

function LeftNavButton(props) {
  const { style, onClick } = props
  return (
    <FaAngleLeft
      className="slick-arrow"
      style={{ ...style }}
      onClick={onClick}
      size="40px"
    ></FaAngleLeft>
  )
}
export default class SimpleSlider extends Component {
  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 7000,
      arrows: true,
      className: "slide",
      nextArrow: <RightNavButton />,
      prevArrow: <LeftNavButton />,
      responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
          },
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
          },
        },
      ],
    }

    return (
      <Slider {...settings}>
        <div className="reviewCard">
          <h1 className="reviewName">Marven Garcia</h1>
          <p className="reviewContent">
            "Fantastic job on my cultural stone wall! Right Choice Renovations
            is a very professional and reliable company. Trustworthy and
            friendly people to deal with. Thanks again!"
          </p>
        </div>
        <div className="reviewCard">
          <h1 className="reviewName">Chau Linh Nguyen</h1>
          <p className="reviewContent">
            "I had Right Choice Renovations complete the interlock for my home,
            and I'm extremely pleased with the results! They are very
            hardworking, knowledgeable and detail-oriented. Reasonably priced
            with an amazing outcome. 10/10 would recommend."
          </p>
        </div>
        <div className="reviewCard">
          <h1 className="reviewName">Paula Stanistreet </h1>
          <p className="reviewContent">
            "Kenny and Maurice are good people. They're getting a job done and
            done well while working around my kids and myself. They know what
            they're doing and they obviously take pride in their work. The parts
            of the painting that are already finished look amazing. I highly
            recommend them and look forward to using their services again in the
            future!"
          </p>
        </div>
        <div className="reviewCard">
          <h1 className="reviewName">Erica Brown</h1>
          <p className="reviewContent">
            "We are very happy with backyard fencing that Right Choice
            Renovations completed for us! Kenny and Mo were professional and
            accommodating in working with our last minute requests and
            specifications. I especially appreciated that they were so attentive
            to detail and ensured that we were happy throughout the building
            process and completed a fantastic, high-quality job. Truly a
            pleasure. Thanks again for a job well done!"
          </p>
        </div>
        <div className="reviewCard">
          <h1 className="reviewName">Robin Spencer</h1>
          <p className="reviewContent">
            "RC Renos have done three jobs for us now. Two laminate floors and
            painting the master bedroom. They are easy to work with and we love
            the quality of their work. We always get three quotes and they have
            the best price. We have reommended them to our friends and would use
            them again."
          </p>
        </div>
        <div className="reviewCard">
          <h1 className="reviewName">Shamayel Ghani</h1>
          <p className="reviewContent">
            "Amazing work with our kitchen backsplash! The grout we had was a
            little harder to work with because of the colour but you adapted
            yourselves to make sure we still got the look we wanted. Thanks so
            much, Maurice and Kenny, for being quick, efficient, and leaving the
            work space cleaned up and how you found it!"
          </p>
        </div>
      </Slider>
    )
  }
}
